// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/23
// +-------------------------------------------------------------
// |Time: 15:25
// +-------------------------------------------------------------
export default [
    {
        path: '/setting/block-list',
        name: "SettingBlockList",
        meta: {
            title: "板块列表"
        },
        component: () => import("@/views/Setting/Block/Index")
    },
]